import { CloudWatchClient, GetMetricDataCommand } from '@aws-sdk/client-cloudwatch';

/**
 * Creates a CloudWatch client using the same credentials & region
 * you used for SES in localStorage.
 */
const getCloudWatchClient = () => {
  const user = JSON.parse(localStorage.getItem('user'));
  if (!user || !user.awsAccessKey || !user.awsSecretKey || !user.region) {
    throw new Error('AWS credentials not found.');
  }
  return new CloudWatchClient({
    region: user.region,
    credentials: {
      accessKeyId: user.awsAccessKey,
      secretAccessKey: user.awsSecretKey,
    },
  });
};

/**
 * Returns CloudWatch metric data for SES (Send, Delivery, Bounce, Complaint)
 * within the given date range.
 * 
 * @param {Date} startTime 
 * @param {Date} endTime 
 * @returns {Promise} array of metric results
 */
const getSesMetricsByRange = async (startTime, endTime) => {
  const client = getCloudWatchClient();

  // Example: we request these metrics from the AWS/SES namespace.
  // You can add or remove metrics as needed (e.g., "Reputation.BounceRate").
  // Period is in seconds (3600 = 1 hour). 
  // For daily data, you could use 86400 (24h), but that might reduce resolution.
  const MetricDataQueries = [
    {
      Id: 'sendData',
      MetricStat: {
        Metric: {
          Namespace: 'AWS/SES',
          MetricName: 'Send',
        },
        Period: 3600,
        Stat: 'Sum',
      },
      ReturnData: true,
    },
    {
      Id: 'deliveryData',
      MetricStat: {
        Metric: {
          Namespace: 'AWS/SES',
          MetricName: 'Delivery',
        },
        Period: 3600,
        Stat: 'Sum',
      },
      ReturnData: true,
    },
    {
      Id: 'bounceData',
      MetricStat: {
        Metric: {
          Namespace: 'AWS/SES',
          MetricName: 'Bounce',
        },
        Period: 3600,
        Stat: 'Sum',
      },
      ReturnData: true,
    },
    {
      Id: 'complaintData',
      MetricStat: {
        Metric: {
          Namespace: 'AWS/SES',
          MetricName: 'Complaint',
        },
        Period: 3600,
        Stat: 'Sum',
      },
      ReturnData: true,
    },
  ];

  const command = new GetMetricDataCommand({
    StartTime: startTime,
    EndTime: endTime,
    MetricDataQueries,
    ScanBy: 'TimestampAscending',
  });

  const response = await client.send(command);
  return response.MetricDataResults;
};

const analyticsService = {
  getSesMetricsByRange,
};

export default analyticsService;
